import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { setGlobalOption, requestResetStats } from '../../HOME/REDUX/actions';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import { HIDDEN, FADE } from '../../HOME/const';
import { COMPETE } from '../const';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';

class Options extends Component {
  handleResetStats = e => {
    if (this.canResetStats()) {
      this.props.hideOptions();
      this.props.requestResetStats(true);
    }
  };

  canResetStats = () => {
    const { mode, stats } = this.props;
    return mode === COMPETE && stats && stats.plays > 0;
  };

  render() {
    const { op } = this.props;
    const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

    return (
      <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
        <div className="options-x" onClick={this.props.hideOptions}>
          ×
        </div>
        <div className={`options-item${this.canResetStats() ? '' : ' options-item-disabled'}`} onClick={this.handleResetStats}>
          <ResetStatsIcon width="30" />
          <span>reset stats</span>
        </div>
        <VolumeControl />
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, setGlobalOption }
)(Options);
